import { gql } from '@apollo/client';

export const GET_ECD_NON_CENTER_BASED_SURVEY = gql`
  query GetECDNonCenterBasedSurvey {
    survey: getECDNonCenterBasedSurvey {
      triggers {
        expression
        fromName
        setToName
        setValue
        type
      }
      pages {
        elements {
          elements {
            category
            choices
            description
            hideNumber
            id
            isRequired
            name
            questionNumber
            readOnly
            requirePhotos
            title
            type
            visible
            visibleIf
            tag
          }
          questionTitleLocation
          name
          title
          type
        }
        name
        title
      }
      showProgressBar
      showQuestionNumbers
      title
      templateId
    }
  }
`;
